<template>
    <div class="sr-fleet-register-button">

        <a v-if="showLogin" class="td-btn primary" href="/accounts/create-or-signin?returnUrl=%2Ffleets%23service-requests">Login or Register</a>
        <button v-if="showRegister" class="td-btn primary" @click="openForm">Register</button>

        <div v-if="showSearch">
            <h2>Try it out now!</h2>
            <search-form></search-form>
        </div>

        <transition name="modal">
            <modal v-if="showForm" @close="closeForm" class="edit-modal" hide-footer>
                <request-register-form @close="closeForm"></request-register-form>
            </modal>
        </transition>
    </div>
</template>

<script>
    import script from './SRFleetRegisterButton';
    export default script;</script>

<style lang="less">
    .sr-fleet-register-button {
        justify-self: center;
    }
</style>